import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { spacings } from '../spacings';
import {
  SectionHeaderText,
  SectionHeaderTextProps,
} from '../TextStyles/SectionHeaderText';

interface OwnProps {
  SectionHeaderTextProps?: SectionHeaderTextProps;
}

interface SectionHeaderProps extends OwnProps, WithStyles<typeof styles> {}

const SectionHeaderBase: FunctionComponent<SectionHeaderProps> = ({
  SectionHeaderTextProps: sectionHeaderTextProps,
  children,
  classes,
}) => (
  <div className={classes.root}>
    <SectionHeaderText {...sectionHeaderTextProps}>
      {children}
    </SectionHeaderText>
  </div>
);

// styled
const styles = (theme: Theme) => {
  const { sectionHeader: sectionHeaderSpacing } = spacings(theme);

  return createStyles({
    root: {
      ...sectionHeaderSpacing,
    },
  });
};

const enhance = compose<SectionHeaderProps, OwnProps>(
  pure,
  withStyles(styles),
);

/**
 * Section header
 *
 * @zeplin {@link https://zpl.io/bPPR5wA }
 */
export const SectionHeader = enhance(SectionHeaderBase);

SectionHeader.displayName = 'SectionHeader';
